<template>
    <a-modal title="Cron表达式" :width="modalWidth" :visible="visible" :confirmLoading="confirmLoading" @ok="handleSubmit"
        @cancel="close" cancelText="关闭">
        <div class="card-container">
            <div class="bottom_box">
                <p><span class="mr10">当前表达式：</span><span class="fwb" style="color:red;">{{this.cron }}</span></p>
            </div>
            <a-tabs type="card">
                <a-tab-pane key="1" type="card">
                    <span slot="tab"> <a-icon type="schedule" /> 秒</span>
                    <a-radio-group v-model="result.second.cronEvery">
                        <a-row>
                            <a-radio value="1">每一秒钟</a-radio>
                        </a-row>
                        <a-row>
                            <a-radio value="2">周期从
                                <a-input-number size="small" v-model="result.second.rangeStart" :min="1" :max="60">
                                </a-input-number>
                                -
                                <a-input-number size="small" v-model="result.second.rangeEnd" :min="0" :max="59">
                                </a-input-number>
                                秒
                            </a-radio>
                        </a-row>
                        <a-row>
                            <a-radio value="3">
                                从
                                <a-input-number size="small" v-model="result.second.incrementStart" :min="0" :max="59">
                                </a-input-number>
                                秒开始
                                每
                                <a-input-number size="small" v-model="result.second.incrementIncrement" :min="1"
                                    :max="60"></a-input-number>
                                秒执行一次
                            </a-radio>
                        </a-row>
                        <a-row>
                            <a-radio value="4">指定(可多选)</a-radio>
                            <a-select style="width:354px;" size="small" mode="multiple"
                                v-model="result.second.specificSpecific">
                                <a-select-option v-for="(val,index) in 60" :key="index" :value="index">{{ index }}
                                </a-select-option>
                            </a-select>
                        </a-row>
                        
                    </a-radio-group>
                </a-tab-pane>
                <a-tab-pane key="2">
                    <span slot="tab">
                        <a-icon type="schedule" />分</span>
                    <div class="tabBody">
                        <a-radio-group v-model="result.minute.cronEvery">
                            <a-row>
                                <a-radio value="1">每分钟</a-radio>
                            </a-row>
                            <a-row>
                                <a-radio value="2">周期从
                                    <a-input-number size="small" v-model="result.minute.rangeStart" :min="1" :max="60">
                                    </a-input-number>
                                    到
                                    <a-input-number size="small" v-model="result.minute.rangeEnd" :min="0" :max="59">
                                    </a-input-number>
                                    分
                                </a-radio>
                            </a-row>
                            <a-row>
                                <a-radio value="3">
                                    从
                                    <a-input-number size="small" v-model="result.minute.incrementStart" :min="0"
                                        :max="59"></a-input-number>
                                    分开始
                                    每隔
                                    <a-input-number size="small" v-model="result.minute.incrementIncrement" :min="1"
                                        :max="60"></a-input-number>
                                    分执行
                                </a-radio>
                            </a-row>
                            <a-row>
                                <a-radio value="4">具体分钟数(可多选)</a-radio>
                                <a-select style="width:340px;" size="small" mode="multiple"
                                    v-model="result.minute.specificSpecific">
                                    <a-select-option v-for="(val,index) in Array(60)" :key="index" :value="index">
                                        {{ index }}</a-select-option>
                                </a-select>
                            </a-row>
                            
                        </a-radio-group>
                    </div>
                </a-tab-pane>
                <a-tab-pane key="3">
                    <span slot="tab">
                        <a-icon type="schedule" /> 时</span>
                    <div class="tabBody">
                        <a-radio-group v-model="result.hour.cronEvery">
                            <a-row>
                                <a-radio value="1">每一小时</a-radio>
                            </a-row>
                            <a-row>
                                <a-radio value="2">周期从
                                    <a-input-number size="small" v-model="result.hour.rangeStart" :min="0" :max="23">
                                    </a-input-number>
                                    到
                                    <a-input-number size="small" v-model="result.hour.rangeEnd" :min="0" :max="23">
                                    </a-input-number>
                                    小时
                                </a-radio>
                            </a-row>
                            <a-row>
                                <a-radio value="3">
                                    从
                                    <a-input-number size="small" v-model="result.hour.incrementStart" :min="0"
                                        :max="23"></a-input-number>
                                    小时开始
                                    每隔
                                    <a-input-number size="small" v-model="result.hour.incrementIncrement" :min="0"
                                        :max="23"></a-input-number>
                                    小时执行
                                </a-radio>
                            </a-row>
                            <a-row>
                                <a-radio class="long" value="4">具体小时数(可多选)</a-radio>
                                <a-select style="width:340px;" size="small" mode="multiple"
                                    v-model="result.hour.specificSpecific">
                                    <a-select-option v-for="(val,index) in Array(24)" :key="index">{{ index }}
                                    </a-select-option>
                                </a-select>
                            </a-row>
                            
                        </a-radio-group>
                    </div>
                </a-tab-pane>
                <a-tab-pane key="4">
                    <span slot="tab">
                        <a-icon type="schedule" /> 天</span>
                    <div class="tabBody">
                        <a-radio-group v-model="result.day.cronEvery">
                            <a-row>
                                <a-radio value="1">每天</a-radio>
                            </a-row>
                            <a-row>
                                <a-radio value="2">不指定</a-radio>
                            </a-row>
                            <a-row>
                                <a-radio value="3">
                                    周期 从
                                    <a-input-number size="small" v-model="result.day.incrementStart" :min="1"
                                        :max="31"></a-input-number>
                                    -
                                    <a-input-number size="small" v-model="result.day.incrementEnd" :min="1"
                                        :max="31"></a-input-number>
                                    日
                                </a-radio>
                            </a-row>
                            <a-row>
                                <a-radio value="4">
                                    从
                                    <a-input-number size="small" v-model="result.day.incrementStart" :min="1" :max="31">
                                    </a-input-number>
                                    日开始
                                    每隔
                                    <a-input-number size="small" v-model="result.day.incrementIncrement" :min="1"
                                        :max="31"></a-input-number>
                                    天执行一次
                                </a-radio>
                            </a-row>
            
                            <a-row>
                                <a-radio value="5">每月
                                    <a-input-number size="small" v-model="result.day.cronDaysNearestWeekday" :min="1"
                                        :max="31"></a-input-number>
                                    号最近的工作日（周一至周五）
                                </a-radio>
                            </a-row>

                            <a-row>
                                <a-radio value="6">本月的最后一天</a-radio>
                            </a-row>

                            <a-row>
                                <a-radio class="long" value="7">指定(可多选)</a-radio>
                                <a-select style="width:354px;" size="small" mode="multiple"
                                    v-model="result.day.specificSpecific">
                                    <a-select-option v-for="(val,index) in Array(31)" :key="index" :value="index+1">
                                        {{ index+1 }}</a-select-option>
                                </a-select>
                            </a-row>
   
                        </a-radio-group>
                    </div>
                </a-tab-pane>
                <a-tab-pane key="5">
                    <span slot="tab">
                        <a-icon type="schedule" /> 月</span>
                    <div class="tabBody">
                        <a-radio-group v-model="result.month.cronEvery">
                            <a-row>
                                <a-radio value="1">每月</a-radio>
                            </a-row>
                            <a-row>
                                <a-radio value="2">不指定</a-radio>
                            </a-row>
                            <a-row>
                                <a-radio value="3">周期 从
                                    <a-input-number size="small" v-model="result.month.rangeStart" :min="1" :max="12">
                                    </a-input-number>
                                    -
                                    <a-input-number size="small" v-model="result.month.rangeEnd" :min="1" :max="12">
                                    </a-input-number>
                                    月
                                </a-radio>
                            </a-row>
                            <a-row>
                                <a-radio value="4">
                                    从
                                    <a-input-number size="small" v-model="result.month.incrementStart" :min="0"
                                        :max="12"></a-input-number>
                                    月开始
                                    每
                                    <a-input-number size="small" v-model="result.month.incrementIncrement" :min="0"
                                        :max="12"></a-input-number>
                                    月执行一次
                                </a-radio>
                            </a-row>
                            <a-row>
                                <a-radio class="long" value="5">指定(可多选)</a-radio>
                                <a-select style="width:354px;" size="small" filterable mode="multiple"
                                    v-model="result.month.specificSpecific">
                                    <a-select-option v-for="(val,index) in Array(12)" :key="index" :value="index+1">
                                        {{ index+1 }}</a-select-option>
                                </a-select>
                            </a-row>
                            
                        </a-radio-group>
                    </div>
                </a-tab-pane>
                <a-tab-pane key="6">
                    <span slot="tab"> <a-icon type="schedule" /> 周</span>
                    <a-radio-group v-model="result.week.cronEvery">
                        <a-row>
                            <a-radio value="1">每周</a-radio>
                        </a-row>
                        <a-row>
                            <a-radio value="2">不指定</a-radio>
                        </a-row>
                        <a-row>
                            <a-radio value="3">
                                周期 从
                                <a-select size="small" v-model="result.week.incrementStart">
                                    <a-select-option v-for="(val,index) in Array(7)" :key="index" :value="index+1">
                                        {{ weekDays[index] }}</a-select-option>
                                </a-select>
                                -
                                <a-select size="small" v-model="result.week.incrementEnd">
                                    <a-select-option v-for="(val,index) in Array(7)" :key="index" :value="index+1">
                                        {{ weekDays[index] }}</a-select-option>
                                </a-select>
                            </a-radio>
                        </a-row>
                        <a-row>
                            <a-radio value="4">第
                                <a-input-number size="small" v-model="result.week.rangeStart" :min="1" :max="7">
                                </a-input-number>
                                周的星期
                           
                                <a-input-number size="small" v-model="result.week.rangeEnd" :min="1" :max="7">
                                </a-input-number>
                            </a-radio>
                        </a-row>
                        <a-row>
                            <a-radio value="5">本月最后一个
                                <a-select size="small" v-model="result.week.lastWeekNum">
                                    <a-select-option v-for="(val,index) in Array(7)" :key="index" :value="index+1">
                                        {{ weekDays[index] }}</a-select-option>
                                </a-select>
                            </a-radio>
                        </a-row>

                        <a-row>
                                <a-radio class="long" value="6">指定(可多选)</a-radio>
                                <a-select style="width:354px;" size="small" mode="multiple"
                                    v-model="result.week.specificSpecific">
                                    <a-select-option v-for="(val,index) in Array(7)" :key="index" :value="index+1">
                                        {{ weekDays[index] }}</a-select-option>
                                </a-select>
                            </a-row>
                    </a-radio-group>
                </a-tab-pane>
                <a-tab-pane key="7">
                    <span slot="tab">
                        <a-icon type="schedule" /> 年</span>
                    <div class="tabBody">
                        <a-radio-group v-model="result.year.cronEvery">
                            <a-row>
                                <a-radio value="1">不指定</a-radio>
                            </a-row>
                            <a-row>
                                <a-radio value="2">每年</a-radio>
                            </a-row>
                            <a-row>
                                <a-radio value="3">周期 从
                                    <a-input-number size="small" v-model="result.year.rangeStart" :min="2019"
                                        :max="2119"></a-input-number>
                                    到
                                    <a-input-number size="small" v-model="result.year.rangeEnd" :min="2019" :max="2119">
                                    </a-input-number>
                                    年之间的每一年
                                </a-radio>
                            </a-row>
                        </a-radio-group>
                    </div>
                </a-tab-pane>
            </a-tabs>

            <div>
                <p class="fwb mt10">{{this.errormessage }}</p>
                <p class="fwb mt10">最近运行时间：</p>
                <p v-for="(item,index) in nexttimeList" :key="index" style="text-align:left;">
                    <span  class="bg-green">{{item}}</span>
                </p>
            </div>
            
        </div>
    </a-modal>
</template>

<script>
export default {
    name:'VueCron',
    props:['data'],
    data(){
        return {
            visible: false,
            confirmLoading:false,
            size:'large',
            weekDays:['天','一','二','三','四','五','六'].map(val=>'星期'+val),
            result: {
                second:{},
                minute:{},
                hour:{},
                day:{},
                week:{},
                month:{},
                year:{}
            },
            defaultValue: {
                second:{
                    cronEvery:'',
                    incrementStart:0,
                    incrementIncrement:1,
                    rangeStart:1,
                    rangeEnd:2,
                    specificSpecific:[],
                },
                minute:{
                    cronEvery:'',
                    incrementStart:0,
                    incrementIncrement:1,
                    rangeStart:1,
                    rangeEnd:2,
                    specificSpecific:[],
                },
                hour:{
                    cronEvery:'',
                    rangeStart:1,
                    rangeEnd:2,
                    incrementStart:0,
                    incrementIncrement:1,
                    specificSpecific:[],
                },
                day:{
                    cronEvery:'',
                    incrementStart:1,
                    incrementEnd:2,
                    incrementIncrement:'1',
                    cronDaysNearestWeekday:1,
                    specificSpecific:[],
                },
                month:{
                    cronEvery:'',
                    rangeStart:1,
                    rangeEnd:2,
                    incrementStart:1,
                    incrementIncrement:1,
                    specificSpecific:[],
                },
                week:{
                    cronEvery:'',
                    rangeStart:1,
                    rangeEnd:1,
                    lastWeekNum:1,
                    specificSpecific:[],
                    incrementStart:1,
                    incrementEnd:2,
                },
                year:{
                    cronEvery:'',
                    rangeStart:2022,
                    rangeEnd: 2025,
                },
                label:''
            },
            nexttimeList:[],
            errormessage:''
        }
    },
    computed: {
        modalWidth(){
            return 608;
        },
        secondsText() {
            let seconds = '';
            let cronEvery=this.result.second.cronEvery||'';
            switch (cronEvery.toString()){
                case '1':
                    seconds = '*';
                    break;
                case '2':
                    seconds = this.result.second.rangeStart+'-'+this.result.second.rangeEnd;
                    break;
                case '3':
                    seconds = this.result.second.incrementStart+'/'+this.result.second.incrementIncrement;
                    break;
                case '4':
                    this.result.second.specificSpecific.map(val=> {seconds += val+','});
                    seconds = seconds.slice(0, -1);
                    break;
            }
            return seconds;
        },
        minutesText() {
            let minutes = '';
            let cronEvery=this.result.minute.cronEvery||'';
            switch (cronEvery.toString()){
                case '1':
                    minutes = '*';
                    break;
                case '2':
                    minutes = this.result.minute.rangeStart+'-'+this.result.minute.rangeEnd;
                    break;
                case '3':
                    minutes = this.result.minute.incrementStart+'/'+this.result.minute.incrementIncrement;
                    break;
                case '4':
                    this.result.minute.specificSpecific.map(val=> {
                        minutes += val+','
                    });
                    minutes = minutes.slice(0, -1);
                    break;
                
            }
            return minutes;
        },
        hoursText() {
            let hours = '';
            let cronEvery=this.result.hour.cronEvery||'';
            switch (cronEvery.toString()){
                case '1':
                    hours = '*';
                    break;
                case '2':
                    hours = this.result.hour.rangeStart+'-'+this.result.hour.rangeEnd;
                    break;
                case '3':
                    hours = this.result.hour.incrementStart+'/'+this.result.hour.incrementIncrement;
                    break;
                case '4':
                    this.result.hour.specificSpecific.map(val=> {
                        hours += val+','
                    });
                    hours = hours.slice(0, -1);
                    break;
                
            }
            return hours;
        },
        daysText() {
            let days='';
            let cronEvery=this.result.day.cronEvery||'';
            switch (cronEvery.toString()){
                case '1':
                    days = "*"
                    break;
                case '2':
                    days = '?';
                    break;
                case '3':
                    days = this.result.day.incrementStart+'-'+this.result.day.incrementEnd;
                    break
                case '4':
                    days = this.result.day.incrementStart+'/'+this.result.day.incrementIncrement;
                    break;
                case '5':
                    days = this.result.day.cronDaysNearestWeekday+"W";
                    break
                case '6':
                    days = "L";
                    break;
                case '7':
                    this.result.day.specificSpecific.map(val=> {
                        days += val+','
                    });
                    days = days.slice(0, -1);
                    break;
                
            }
            return days;
        },
        weeksText() {
            let weeks = '';
            let cronEvery=this.result.week.cronEvery||'';
            switch (cronEvery.toString()){
                case '1':
                    //每周
                    weeks = '*';
                    break;
                case '2':
                    weeks = '?';
                    break;
                case '3':
                    weeks = this.result.week.incrementStart+'-'+this.result.week.incrementEnd;
                    //周期
                    break;
                case '4':
                    weeks = this.result.week.rangeStart+'/'+this.result.week.rangeEnd;
                    break;
                
                case '5':
                    weeks = this.result.week.lastWeekNum+'L';
                    break;
                case '6':
                    this.result.week.specificSpecific.map(val=> {
                        weeks += val+','
                    });
                    weeks = weeks.slice(0, -1);
                    break;
               
            }
            return weeks;
        },
        monthsText() {
            let months = '';
            let cronEvery=this.result.month.cronEvery||'';
            switch (cronEvery.toString()){
                case '1':
                    months = '*';
                    break;
                case '2':
                    months = '?';
                    break;
                case '3':
                    months = this.result.month.rangeStart+'-'+this.result.month.rangeEnd;
                    break;
                case '4':
                    months = this.result.month.incrementStart+'/'+this.result.month.incrementIncrement;
                    break;
                case '5':
                    this.result.month.specificSpecific.map(val=> {
                        months += val+','
                    });
                    months = months.slice(0, -1);
                    break;
                
            }
            return months;
        },
        yearsText() {
            let years = '';
            let cronEvery=this.result.year.cronEvery||'';
            switch (cronEvery.toString()){
                case '1':
                    years = '';
                    break;
                case '2':
                    years = '*';
                    break;
                case '3':
                    years = this.result.year.rangeStart+'-'+this.result.year.rangeEnd;
                    break;
            }
            return years;
        },
        cron(){
            return `${this.secondsText||'*'} ${this.minutesText||'*'} ${this.hoursText||'*'} ${this.daysText||'*'} ${this.monthsText||'*'} ${this.weeksText||'?'} ${this.yearsText||''}`
        },
    },
    watch:{
        visible:{
            handler() {
                let label = this.data;
                if(label){
                    this.secondsReverseExp(label)
                    this.minutesReverseExp(label);
                    this.hoursReverseExp(label);
                    this.daysReverseExp(label);
                    this.monthsReverseExp(label);
                    this.weekReverseExp(label);
                    this.yearReverseExp(label);
                    JSON.parse(JSON.stringify(label));
                }else {
                    this.result = JSON.parse(JSON.stringify(this.defaultValue));
                }
                this.getNextTime()
            }
        },
        cron:{
            handler(){
                this.getNextTime()
            }
        }
    },
    methods: {
        //获取下次执行时间
        getNextTime(){
            let that = this;
            that.$store.dispatch({
                type: 'jobcenter/nextTriggerTime',
                params: {
                    scheduleType:'CRON',
                    scheduleConf:this.cron,
                    urlparams:false,
                }
            }).then((res) => {
                if(res.data.code == 200){
                    that.nexttimeList = res.data.content
                    that.errormessage = ""
                }
                else{
                    that.nexttimeList = []
                    that.errormessage = res.data.msg
                }
            });
        },
        show(){
            this.visible = true;
        },
        handleSubmit(){
            this.$emit('ok',this.cron);
            this.close();
            this.visible = false;
        },
        close(){
            this.visible = false;
        },
        secondsReverseExp(seconds) {
            let val =  seconds.split(" ")[0];
            //alert(val);
            let second = {
                cronEvery:'',
                incrementStart:0,
                incrementIncrement:1,
                rangeStart:1,
                rangeEnd:2,
                specificSpecific:[],
            };
            if(val.includes('*')){
                second.cronEvery = '1';
            }
            else if(val.includes('-')){
                second.cronEvery = '2';
                second.rangeStart = val.split('-')[0];
                second.rangeEnd = val.split('-')[1];
            }
            else if(val.includes('/')){
                second.cronEvery = '3';
                second.incrementStart = val.split('/')[0];
                second.incrementIncrement = val.split('/')[1];
            }
            else{
                second.cronEvery = '4';
                second.specificSpecific = val.split(',').map(Number).sort();
            }
           
            this.result.second = second;
        },
        minutesReverseExp(minutes) {
            let val =  minutes.split(" ")[1];
            let minute = {
                cronEvery:'',
                incrementStart:0,
                incrementIncrement:1,
                rangeStart:1,
                rangeEnd:2,
                specificSpecific:[],
            }
            if(val.includes('*')){
                minute.cronEvery = '1';

            }
            else if(val.includes('-')){
                minute.cronEvery = '2';
                minute.rangeStart = val.split('-')[0];
                minute.rangeEnd = val.split('-')[1];
            }
            else if(val.includes('/')){
                minute.cronEvery = '3';
                minute.incrementStart = val.split('/')[0];
                minute.incrementIncrement = val.split('/')[1];
            }
            else{
                minute.cronEvery = '4';
                minute.specificSpecific = val.split(',').map(Number).sort();
            }
           
            this.result.minute = minute;
        },
        hoursReverseExp(hours) {
            let val =  hours.split(" ")[2];
            let hour ={
                cronEvery:'',
                rangeStart:1,
                rangeEnd:2,
                incrementStart:0,
                incrementIncrement:1,
                specificSpecific:[],
            };
            if(val.includes('*')){
                hour.cronEvery = '1';
            }
            else if(val.includes('-')){
                hour.cronEvery = '2';
                hour.rangeStart = val.split('-')[0];
                hour.rangeEnd = val.split('-')[1];
            }
            else if(val.includes('/')){
                hour.cronEvery = '3';
                hour.incrementStart = val.split('/')[0];
                hour.incrementIncrement = val.split('/')[1];
            }
            else {
                hour.cronEvery = '4';
                hour.specificSpecific = val.split(',').map(Number).sort();
            }
            
            this.result.hour = hour;
        },
        daysReverseExp(cron) {
            let days =  cron.split(" ")[3];
            let day ={
                cronEvery:'',
                incrementStart:1,
                incrementEnd:2,
                incrementIncrement:'1',
                cronDaysNearestWeekday:1,
                specificSpecific:[],
            };
            if(days.includes('*')){
                day.cronEvery = '1';
            }
            else if(days.includes('?')){
                day.cronEvery = '2';
            }
            else if(days.includes('-')){
                day.cronEvery = '3';
                day.incrementStart = days.split('-')[0];
                day.incrementEnd = days.split('-')[1];
            }   
            else if(days.includes('/')){
                day.cronEvery = '4';
                day.incrementStart = days.split('/')[0];
                day.incrementIncrement = days.split('/')[1];
            }  
            else if(days.includes('W')){
                day.cronEvery = '5';
                day.cronDaysNearestWeekday = days.split('W')[0];
            } 
            else if(days.includes('L')){
                day.cronEvery = '6';

            }   
            else{
                day.cronEvery = '7';
                day.specificSpecific = days.split(',').map(Number).sort();
            }
            
            this.result.day = day;
        },
        monthsReverseExp(cron) {
            let months = cron.split(" ")[4];
            let month = {
                cronEvery:'',
                rangeStart:1,
                rangeEnd:2,
                incrementStart:1,
                incrementIncrement:1,
                specificSpecific:[],
            };
            if(months.includes('*')){
                month.cronEvery = '1';
            }
            else if(months.includes('?')){
                month.cronEvery = '2';
            }
            else if(months.includes('-')){
                month.cronEvery = '3';
                month.rangeStart = months.split('-')[0];
                month.rangeEnd = months.split('-')[1];
            }
            else if(months.includes('/')){
                month.cronEvery = '4';
                month.incrementStart = months.split('/')[0];
                month.incrementIncrement = months.split('/')[1];
            }
            else{
                month.cronEvery = '5';
                month.specificSpecific = months.split(',').map(Number).sort();
            }
            
            this.result.month = month;
        },
        weekReverseExp(weeks) {
            let val =  weeks.split(" ")[5];
            let week ={
                cronEvery:'',
                rangeStart:1,
                rangeEnd:1,
                lastWeekNum:1,
                specificSpecific:[],
                incrementStart:1,
                incrementEnd:2,
            };
            if(val.includes('*')){
                week.cronEvery = '1';
            }
            if(val.includes('?')){
                week.cronEvery = '2';
            }
            else if(val.includes('-')){
                week.cronEvery = '3';
                week.incrementStart = val.split('-')[0];
                week.incrementEnd = val.split('-')[1];
            }
            else if(val.includes('/')){
                week.cronEvery = '4';
                week.rangeStart = val.split('/')[0];
                week.rangeEnd = val.split('/')[1];
            }
            else if(val.includes('L')){
                week.cronEvery = '5';
                week.lastWeekNum = val.split('L')[0];
            }
            else {
                week.cronEvery = '6';
                week.specificSpecific = val.split(',').map(Number).sort();
            }
            
            this.result.week = week;
        },
        yearReverseExp(cron) {
            let years = cron.split(" ")[6];
            years = years == undefined ? '' : years
            let year = {
                cronEvery:'',
                rangeStart:2022,
                rangeEnd: 2025,
            };
            switch (true){
                case years.includes('*'):
                    year.cronEvery = '2';
                    break;
                case years.includes('-'):
                    year.cronEvery = '3';
                    year.rangeStart = years.split('-')[0];
                    year.rangeEnd = years.split('-')[1];
                    break;
                default:
                    year.cronEvery = '1';
            }
            this.result.year = year;
        }
    }
}
</script>
 
<style scoped>
.card-container {
    background: #fff;
    overflow: hidden;
    padding: 0 12px 12px 12px;
    position: relative;
    width: 100%;
}

.ant-tabs {
    border: 1px solid #e6ebf5;
    padding: 0;


}

.ant-tabs-tabpane {
    padding: 15px;


}

.ant-select,
.ant-input-number {
    width: 100px;
}

.ant-row {
    margin: 10px 0;
}

.ant-tabs-bar {
    margin: 0;
    outline: none;
    border-bottom: none;


}

.ant-tabs-tab-active.ant-tabs-tab {
    color: #409eff;
    background-color: #fff !important;
    border-right: 1px solid #e6ebf5 !important;
    border-left: 1px solid #e6ebf5 !important;
    border-bottom: 1px solid #fff !important;
    font-weight: normal;
    transition: none !important;
}

.ant-tabs-nav-container {
    margin: 0;

}

.ant-tabs-tab {
    padding: 0 24px !important;
    background-color: #f5f7fa !important;
    margin-right: 0px !important;
    border-radius: 0;
    line-height: 38px;
    border: 1px solid transparent !important;
    border-bottom: 1px solid #e6ebf5 !important;
}

.container-widthEn {
    width: 755px;
}

.container-widthCn {
    width: 608px;
}

.language {
    text-align: center;
    position: absolute;
    right: 13px;
    top: 13px;
    border: 1px solid transparent;
    height: 40px;
    line-height: 38px;
    font-size: 16px;
    color: #409eff;
    z-index: 1;
    background: #f5f7fa;
    outline: none;
    width: 47px;
    border-bottom: 1px solid #e6ebf5;
    border-radius: 0;
}

.card-container .bottom {
    display: flex;
    justify-content: left;
    padding: 0 0 10px 0;

}

.cronButton {
    margin: 0 10px;
    line-height: 40px;
}


.a-row {
    margin: 10px 0;


}

.a-input-number {
    width: 110px;
}


.a-select {
    width: 354px;
}


</style>

 
 
 
 